import { actionTypes } from '~/src/features/full-buy/store/index';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';

// @todo remove action and move implementation to the initialization method
export const setProducts = (products: TProduct[]) => ({
    type: actionTypes.SET_PRODUCTS,
    payload: products,
});
